export const ANIM_INTERVAL_MS = 100;
export const BREATHING_CYCLE_FRAMES = 10;
export const TOKEN_COUNTUP_EASING_FACTOR = 0.25;
export const TOKEN_COUNTUP_MIN_STEP = 8;

export const PANEL_DIM_COLOR = "\x1b[38;2;160;150;180m";

export const SYM_INDICATOR = "⏺";
export const SYM_THINKING = "◇";

export const DEFAULT_BODY_H = 6;
